import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import React from 'react'
import { render } from 'react-dom'
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './store'
import App from './containers/app'
import './index.css'

const target = document.querySelector('#root');
var u = navigator.userAgent;
var isEdge = u.indexOf("Edge") > -1;
var isQQ = u.indexOf("MQQBrowser") > -1;
var iswechat = u.indexOf("chat") > -1;
var isSafari = u.indexOf("Safari") > -1;
var isChrome = u.toLowerCase().match(/chrome/); //排除双核
if (
    !(isChrome ||
        isEdge ||
        isQQ ||
        isSafari)
) {
    document.getElementById('root').innerHTML = ''
    document.getElementById('browserTips').className = 'showCompatibility'
}else{
        render(
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <App />
                    </ConnectedRouter>
                </Provider>,
                target
            );
            registerServiceWorker();

}
// var Sys = {};
// var ua = navigator.userAgent.toLowerCase();
// console.log(ua)
// var s;
// (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
//     (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
//         (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
//             (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
//                 (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
//                     (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
//
// if (Sys.ie){
//     document.getElementById('root').innerHTML = ''
//     document.getElementById('browserTips').className = ''
// }else if(Sys.chrome){
//         var version = Sys.chrome.split('.')[0]
//         if (parseInt(version)<47){
//             document.getElementById('root').innerHTML = ''
//             document.getElementById('browserTips2').className = ''
//         }else{
//             render(
//                 <Provider store={store}>
//                     <ConnectedRouter history={history}>
//                         <App />
//                     </ConnectedRouter>
//                 </Provider>,
//                 target
//             );
//             registerServiceWorker();
//          }
// }else{
//     document.getElementById('root').innerHTML = ''
//     document.getElementById('browserTips').className = ''
// }
//




// WEBPACK FOOTER //
// ./src/index.js